import ThemedPrice, { defaultProps, propTypes } from './ThemedPrice';

export default ThemedPrice;
export { defaultProps, propTypes };
